import { render, staticRenderFns } from "./LayoutVerticalComp.vue?vue&type=template&id=d568e032&"
import script from "./LayoutVerticalComp.vue?vue&type=script&lang=js&"
export * from "./LayoutVerticalComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports